import { UploadedReadedFile } from 'shared/lib/components/controls/uploadArea/uploadArea';

export class UploadedFileOrString {
  private _uploadedFileOrString: UploadedReadedFile | string;

  constructor(uploadedFileOrString: UploadedReadedFile | string) {
    this._uploadedFileOrString = uploadedFileOrString;
  }

  public get src() {
    return typeof this._uploadedFileOrString === 'string'
      ? this._uploadedFileOrString
      : this._uploadedFileOrString.dataUrl;
  }

  public get file() {
    return typeof this._uploadedFileOrString === 'string'
      ? null
      : this._uploadedFileOrString.originalFile;
  }
}
